import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { QRCodeSVG } from 'qrcode.react'
import { continueOnIphoneHref, type ContinueOnIphonePlacement } from '../lib/appStoreCpp'

const NUDGE_COPY = 'Get a nudge when your next question is ready: continue on your iPhone.'

// Desktop only. The QR is aria-hidden; the link carries the accessible name.
export default function ContinueOnIphone({ placement }: { placement: ContinueOnIphonePlacement }) {
  const href = continueOnIphoneHref(placement)
  return (
    <Box
      sx={{
        display: { xs: 'none', sm: 'flex' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        mt: 3,
        p: 2,
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)',
        background: 'var(--surface)',
      }}
    >
      <a href={href} target="_blank" rel="noopener noreferrer" aria-label={NUDGE_COPY}>
        <QRCodeSVG value={href} size={84} marginSize={0} aria-hidden="true" />
      </a>
      <Typography sx={{ color: 'var(--ink-2)', fontSize: 14, maxWidth: '32ch' }}>{NUDGE_COPY}</Typography>
    </Box>
  )
}
